import { paymentConfig } from "./paymentConfig";

export const PAYMENT_APP_BASE_URL = paymentConfig.paymentAppBaseUrl;
export const QUIZ_IMAGE_BASE_URL = paymentConfig.quizImageBaseUrl;

export function buildPaymentAppUrl(path) {
  return new URL(path, PAYMENT_APP_BASE_URL).toString();
}
